import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import Modal from '../components/Modal';
import api from '../hooks/api';

const emptyForm = { name: '', branch_id: '' };

export default function DepartmentsPage() {
  const { user } = useAuth();
  const [departments, setDepartments] = useState([]);
  const [branches, setBranches] = useState([]);
  const [modal, setModal] = useState(null);
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState(emptyForm);
  const [error, setError] = useState('');
  const [filterBranch, setFilterBranch] = useState('');

  const loadDepts = useCallback(async () => {
    const params = filterBranch ? '?branch_id=' + filterBranch : '';
    setDepartments(await api.get('/api/departments' + params));
  }, [filterBranch]);

  const loadBranches = useCallback(async () => {
    setBranches(await api.get('/api/branches'));
  }, []);

  useEffect(() => { loadDepts(); }, [loadDepts]);
  useEffect(() => { loadBranches(); }, [loadBranches]);

  function openAdd() { setForm(emptyForm); setEditId(null); setError(''); setModal(true); }

  function openEdit(d) {
    setForm({ name: d.name, branch_id: d.branch_id });
    setEditId(d.id); setError(''); setModal(true);
  }

  function set(k, v) { setForm(f => ({ ...f, [k]: v })); }

  async function handleSave(e) {
    e.preventDefault(); setError('');
    try {
      if (editId) await api.put('/api/departments/' + editId, form);
      else await api.post('/api/departments', form);
      setModal(null); loadDepts();
    } catch (err) { setError(err.message); }
  }

  async function handleDelete(d) {
    if (!window.confirm(`Delete department "${d.name}"?`)) return;
    try { await api.delete('/api/departments/' + d.id); loadDepts(); }
    catch (err) { alert(err.message); }
  }

  return (
    <div className="page">
      <div className="page-header">
        <h1 className="page-title" style={{ margin: 0 }}>Departments</h1>
        {(user?.role === 'admin' || user?.role === 'manager') &&
          <button className="btn btn-primary" onClick={openAdd}>+ Add Department</button>}
      </div>
      <div className="filters">
        {user?.role === 'admin' && (
          <select value={filterBranch} onChange={e => setFilterBranch(e.target.value)}>
            <option value="">All Branches</option>
            {branches.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}
          </select>
        )}
      </div>
      <div className="table-wrap">
        <table className="table">
          <thead>
            <tr><th>Name</th><th>Branch</th><th>Created</th><th>Actions</th></tr>
          </thead>
          <tbody>
            {departments.map(d => (
              <tr key={d.id}>
                <td style={{ fontWeight: 600 }}>{d.name}</td>
                <td>{d.branch_name}</td>
                <td>{d.created_at ? new Date(d.created_at).toLocaleDateString() : '—'}</td>
                <td style={{ whiteSpace: 'nowrap' }}>
                  {(user?.role === 'admin' || user?.role === 'manager') &&
                    <button className="btn btn-ghost btn-sm" onClick={() => openEdit(d)}>Edit</button>}
                  {user?.role === 'admin' &&
                    <button className="btn btn-danger btn-sm" style={{ marginLeft: 6 }} onClick={() => handleDelete(d)}>Delete</button>}
                </td>
              </tr>
            ))}
            {departments.length === 0 && <tr><td colSpan={4} className="empty">No departments found</td></tr>}
          </tbody>
        </table>
      </div>

      {modal && (
        <Modal title={editId ? 'Edit Department' : 'Add Department'} onClose={() => setModal(null)}>
          {error && <div className="alert alert-error">{error}</div>}
          <form onSubmit={handleSave}>
            <div className="form-group">
              <label>Name *</label>
              <input value={form.name} onChange={e => set('name', e.target.value)} required autoFocus />
            </div>
            <div className="form-group">
              <label>Branch *</label>
              <select value={form.branch_id} onChange={e => set('branch_id', e.target.value)} required>
                <option value="">Select branch…</option>
                {branches.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}
              </select>
            </div>
            <div className="form-actions">
              <button type="button" className="btn btn-ghost" onClick={() => setModal(null)}>Cancel</button>
              <button type="submit" className="btn btn-primary">{editId ? 'Save Changes' : 'Add Department'}</button>
            </div>
          </form>
        </Modal>
      )}
    </div>
  );
}
